import { useEffect, useState } from 'react';

const JoinTeam = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      <div className="bg-[#EFEAE7] min-h-screen py-16">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl">

          {/* Header Section */}
          <section className="mb-24">
            <h2 className="mb-8">
              <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">JOIN OUR</span>
              <br />
              <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold">TEAM</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <p className="font-['Outfit'] text-base md:text-lg mb-8 leading-relaxed">
                  We're always looking for passionate individuals to join our family. Whether you're an experienced
                  chef, a friendly server, or someone eager to learn, we'd love to hear from you.
                </p>
                <p className="font-['Outfit'] text-base md:text-lg leading-relaxed">
                  At Lotus Story, we believe in creating not just great food, but also a supportive environment where
                  our team can grow and thrive together.
                </p>
              </div>
              <div>
                <img
                  src="/jointeam.jpg"
                  alt="Join Our Team"
                  className="w-full h-auto object-contain rounded-lg"
                />
              </div>
            </div>
          </section>

          {/* Why Join Us Section */}
          <section className="mb-24">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <img
                  src="/jointeam2.jpg"
                  alt="Our Team at Work"
                  className="w-full h-auto object-contain rounded-lg"
                />
              </div>
              <div className="flex flex-col items-start">
                <h2 className="mb-8 self-end">
                  <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">WHY</span>
                  <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold ml-2">JOIN US?</span>
                </h2>
                <div className="space-y-6 text-right self-end">
                  <div>
                    <h3 className="font-['Outfit'] text-xl font-semibold mb-2 text-[#4F6632]">Growth Opportunities</h3>
                    <p className="font-['Outfit'] text-base md:text-lg leading-relaxed">
                      We invest in our team's development with training and career advancement paths
                    </p>
                  </div>
                  <div>
                    <h3 className="font-['Outfit'] text-xl font-semibold mb-2 text-[#4F6632]">Family Environment</h3>
                    <p className="font-['Outfit'] text-base md:text-lg leading-relaxed">
                      Work in a supportive, collaborative atmosphere where everyone matters
                    </p>
                  </div>
                  <div>
                    <h3 className="font-['Outfit'] text-xl font-semibold mb-2 text-[#4F6632]">Competitive Benefits</h3>
                    <p className="font-['Outfit'] text-base md:text-lg leading-relaxed">
                      Enjoy competitive pay, flexible schedules, and employee perks
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
              <div>
                <h2 className="mb-8">
                  <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-3xl md:text-4xl font-bold">READY TO</span>
                  <span className="font-['Playfair_Display_SC'] text-black text-3xl md:text-4xl font-bold ml-2">JOIN?</span>
                </h2>
                <p className="font-['Outfit'] text-base md:text-lg mb-8 leading-relaxed">
                  Send your CV and a brief introduction to us. We're excited to meet passionate individuals who want
                  to be part of the Lotus Story family.
                </p>
                <a
                  href="mailto:lotustoryrestaurant@gmail.com"
                  className="inline-block px-8 py-3 border border-[#4F6632] text-[#4F6632] rounded-full font-['Outfit'] hover:bg-[#4F6632] hover:text-white transition-colors"
                >
                  Send Your CV
                </a>
              </div>
              <div>
                <img
                  src="/jointeam3.jpg"
                  alt="Our team culture"
                  className="w-full h-auto object-contain rounded-lg"
                />
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default JoinTeam;
